import React, { Component } from 'react'
import { NavLink } from 'react-router-dom';
import MobileMenu from './MobileMenu';
import './Sidebar.css';
import { withTranslation} from 'react-i18next';

export class MobileHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {isShown: "closed"};
    }

    render() {

        const { t } = this.props;

        let handleChange = async () => {
            if (this.isShown === "closed") {
                this.setState({isShown: "open"});
            } else {
                this.setState({isShown: "closed"});
            }
        }

        return (
            <div>
                <div id="hamborgari" onClick={handle => {handleChange();}} className={this.isShown}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div id="menu" className={this.isShown}>
                    <MobileMenu/>
                </div>
                <div className="mobile-header"><h1 className="logo"><NavLink to="/notandi/dashboard" activeClassName="selected"><span></span></NavLink></h1></div>
                <div className='mobile-footer'>
                    <div className='menuitem'>
                        <NavLink to="/notandi/samskipti" activeClassName="selected"><i className="fa-light fa-inbox"></i><br/> {t('menu.samskipti')}</NavLink>
                    </div><div className='menuitem'>
                        <NavLink to="/notandi/skyrsla" activeClassName="selected"><i className="fa-light fa-chart-simple"></i><br/> {t('menu.skyrslur')}</NavLink>
                    </div><div className='menuitem'>
                        <NavLink to="/notandi/samskipti" activeClassName="selected"><i className="fa-light fa-inbox"></i><br/> {t('menu.samskipti')}</NavLink>
                    </div><div className='menuitem'>
                        <NavLink to="/notandi/lyfjaaminning" activeClassName="selected"><i className="fa-light fa-books"></i><br/> Fræðsluefni</NavLink>
                    </div><div className='menuitem'>
                        <NavLink to="/notandi/fraedsluefni" activeClassName="selected"><i className="fa-sharp fa-light fa-notebook"></i><br/> {t('menu.journal')}</NavLink>
                    </div>
                </div>
            </div>
            )

    }
}

export default withTranslation()(MobileHeader);